import { SOURCE_TYPES } from '@/trackMatching/trackMatchingTypes';
import { parsePositiveWholeId, parseRawDdexRowId } from '@/trackMatching/rawDdexRowId';

/** The record a Track Matching row stands for, in the shape the side peek opens. */
export interface TrackMatchRecord {
  entityId: 'LiveTrack' | 'RawDdexTrack';
  recordId: number;
}

/**
 * Says which record a Track Matching row opens when you click it.
 * A Live Track row opens its Live Track.
 * A Raw DDEX row opens the Raw DDEX track named in its `d_<id>` row id.
 * A Spotify row returns null, because Spotify tracks have no record in the admin.
 * The "show more" and "show less" rows return null, and so does any row whose id does not parse.
 */
export function trackMatchRecordFor(row: Record<string, unknown>): TrackMatchRecord | null {
  if (row.source === SOURCE_TYPES.LIVE_TRACK) {
    const recordId = parsePositiveWholeId(row.id);
    return recordId === null ? null : { entityId: 'LiveTrack', recordId };
  }
  if (row.source === SOURCE_TYPES.RAW_DDEX) {
    const recordId = parseRawDdexRowId(row.id);
    return recordId === null ? null : { entityId: 'RawDdexTrack', recordId };
  }
  return null;
}
